import { Button, GridItem, IconButton, Text } from "@chakra-ui/react";
import { MdAdd } from "react-icons/md";
import { t } from "i18next";
import { FaTrash } from "react-icons/fa";

function CategoryModalGridItemsSection({ modalData, formData, numberOfColumns, getEmptyRow, mapRow }) {
  const { editData } = modalData;
  const { fields, append, remove } = formData;

  return (
    <>
      {fields.map((row, index) => {
        const gridItems = [];

        gridItems.push(...mapRow(row, index));

        // Adding row removal button if it is not edit modal
        if (!editData) {
          gridItems.push(<IconButton
            type="button"
            icon={<FaTrash size="18" />}
            width="100%"
            color="esg_red"
            variant="ghost"
            disabled={fields.length === 1}
            onClick={() => {
              remove(index);
            }}
          />);
        }

        return gridItems.map((gridItem, gridItemIndex) => {
          // To the number of columns we add one action column (if it's not in edit mode)
          const totalNumberOfColumns = numberOfColumns + (editData ? 0 : 1);

          return <GridItem
            key={`category-modal-item-${gridItemIndex}`}
            borderWidth={"1px"}
            pl="4" pr="4" pt="2" pb="2"
            display="flex"
            alignItems="center"
            colSpan={editData ? 2 : gridItemIndex === totalNumberOfColumns - 1 ? 1 : 2}
            wordBreak="break-word"
          >
            {gridItem}
          </GridItem>;
        });
      })}

      {/* Last grid item (row) is spanning over all the columns and this is how we calculate it. */}
      {/* We have 1 column (the action column) with colSpan = 1, and all other columns have colSpan = 2 */}
      {!editData && <GridItem
        colSpan={(numberOfColumns * 2) + 1}
        borderWidth={"1px"}
        pr="4" pt="2" pb="2"
        display="flex"
        alignItems="center"
      >
        <Button
          variant="ghost"
          display="flex"
          alignItems="center"
          onClick={() => {
            append(getEmptyRow(), { shouldFocus: false });
          }}
          _focus={{
            outline: "none",
            textDecoration: "underline"
          }}
        >
          <IconButton
            as="div"
            variant="outline"
            borderRadius="full"
            size="sm"
            tabIndex={-1}
            pointerEvents="none"
            flexShrink="0"
            icon={<MdAdd size="20" />}
          />
          <Text marginInlineStart="2">{t("buttons.addAnotherItem")}</Text>
        </Button>
      </GridItem>}
    </>
  );
}

export default CategoryModalGridItemsSection;